import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginService } from '../../features/auth/login.service';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(private http: HttpClient) {}
  baseUrl: string = environment.baseUrl;

  getAllAcc(): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/getaccounts`, {});
  }

  getAllAccounts(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/getaccountsbyadmin`, payload);
  }

  createAccount(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/createaccount`, payload);
  }

  updateAccount(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/updateaccount`, payload);
  }

  deleteAccount(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/deleteaccount`, { id });
  }
}
